/* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-15 16:10 VN — WEB-20261015-suzitee-xmas-collection
   Đã làm: JS trang Christmas — mở/đóng drawer Filter & Sort (Esc, scrim, khoá cuộn, trả focus), đổi sort giữ
   nguyên query (view/filter/preview), "Load more" nạp trang kế qua Section Rendering API rồi nối card,
   "Show all" trong nhóm filter dài, "Read more" SEO. Không MutationObserver, không timer lặp; mọi handler try/catch. */
(function () {
  'use strict';
  var root = document.querySelector('[data-szx]');
  if (!root || root.__szx) return;
  root.__szx = true;
  var drawer = document.querySelector('[data-szx-drawer]');
  var lastFocus = null;

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    document.documentElement.classList.add('szx-lock');
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    var b = document.querySelector('[data-szx-open]'); if (b) b.setAttribute('aria-expanded', 'true');
    var x = drawer.querySelector('.szx-drawer__x'); if (x) x.focus({ preventScroll: true });
  }
  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('szx-lock');
    var b = document.querySelector('[data-szx-open]'); if (b) b.setAttribute('aria-expanded', 'false');
    setTimeout(function () { drawer.hidden = true; }, 260);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    try {
      var t = e.target;
      if (t.closest('[data-szx-open]')) { e.preventDefault(); openDrawer(); return; }
      if (t.closest('[data-szx-close]')) { e.preventDefault(); closeDrawer(); return; }
      var more = t.closest('[data-szx-fmore]');
      if (more) {
        var opts = more.previousElementSibling;
        if (opts) { opts.classList.add('is-all'); more.remove(); }
        return;
      }
      var seo = t.closest('[data-szx-seo-toggle]');
      if (seo) {
        var box = seo.closest('.szx-seo');
        var open = box.classList.toggle('is-open');
        seo.setAttribute('aria-expanded', open ? 'true' : 'false');
        seo.textContent = open ? 'Show less' : 'Read more';
        return;
      }
      var lm = t.closest('[data-szx-loadmore]');
      if (lm) { e.preventDefault(); loadMore(lm); }
    } catch (err) { /* không chặn điều hướng mặc định nếu lỗi */ }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  // Sort ở toolbar: giữ mọi query hiện có (view, filter.*, preview_theme_id), bỏ page.
  var sortSel = root.querySelector('[data-szx-sort]');
  if (sortSel) sortSel.addEventListener('change', function () {
    try {
      var u = new URL(location.href);
      u.searchParams.set('sort_by', sortSel.value);
      u.searchParams.delete('page');
      location.href = u.toString();
    } catch (err) {}
  });

  // Drawer submit: bỏ ô giá rỗng để URL gọn.
  var form = document.querySelector('[data-szx-form]');
  if (form) form.addEventListener('submit', function () {
    try {
      form.querySelectorAll('input[type="number"]').forEach(function (i) { if (i.value === '') i.disabled = true; });
    } catch (err) {}
  });

  // Load more: Section Rendering API (?section_id=) → nối card, cập nhật đếm/thanh tiến độ/URL.
  var page = parseInt(root.getAttribute('data-page'), 10) || 1;
  var pages = parseInt(root.getAttribute('data-pages'), 10) || 1;
  var sectionId = root.getAttribute('data-section-id');
  var grid = root.querySelector('[data-szx-grid]');
  function loadMore(btn) {
    if (!grid || !sectionId || page >= pages || btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    var u = new URL(location.href);
    u.searchParams.set('page', String(page + 1));
    var pageUrl = u.toString();
    u.searchParams.set('section_id', sectionId);
    fetch(u.toString(), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = doc.querySelectorAll('[data-szx-grid] > .szx-card');
        if (!cards.length) throw new Error('empty');
        var frag = document.createDocumentFragment();
        cards.forEach(function (c) { frag.appendChild(document.importNode(c, true)); });
        grid.appendChild(frag);
        page += 1;
        var shown = grid.children.length;
        var oldMore = root.querySelector('[data-szx-more]');
        var newMore = doc.querySelector('[data-szx-more]');
        if (oldMore) {
          var total = parseInt(oldMore.getAttribute('data-total'), 10) || 0;
          var s = oldMore.querySelector('[data-szx-shown]');
          if (s) s.textContent = String(shown);
          var bar = oldMore.querySelector('[data-szx-bar]');
          if (bar && total) bar.style.width = Math.min(100, Math.round(shown * 100 / total)) + '%';
          var pg = oldMore.querySelector('.szx-pages'), npg = newMore && newMore.querySelector('.szx-pages');
          if (pg && npg) pg.innerHTML = npg.innerHTML;
        }
        if (page >= pages) { btn.remove(); }
        else { var nx = new URL(pageUrl); nx.searchParams.set('page', String(page + 1)); btn.setAttribute('href', nx.toString()); }
        try { history.replaceState(null, '', pageUrl); } catch (e) {}
      })
      .catch(function () { location.href = btn.getAttribute('href'); })
      .finally(function () { btn.removeAttribute('aria-busy'); });
  }
})();
